import AxiosManager from "../_axiosManager";

export async function getFaqDetail(faqId: string) {
  const res = await AxiosManager.getInstance().get(
    `/admin/manage/faq/${faqId}`,
  );

  return res;
}

export async function postFaq(body: any) {
  const res = await AxiosManager.getInstance().post("/admin/manage/faq", body);

  return res;
}

export async function putFaq({ faqId, body }: any) {
  const res = await AxiosManager.getInstance().put(
    `/admin/manage/faq/${faqId}`,
    body,
  );

  return res;
}

export async function delFaq(faqId: string) {
  const res = await AxiosManager.getInstance().delete(
    `/admin/manage/faq/${faqId}`,
  );

  return res;
}
